import React from 'react';
import styles from '../styles/scss/components/heroSimple.module.scss';
import Imgix from "react-imgix"

// datocms-assets.com supports imgix params; other hosts ignore the query string
const sizedSrc = (url, width) =>
    `${url}${url.includes('?') ? '&' : '?'}w=${width}&auto=format`

const simpleHero = (props) => {
    const { image, mobileimage = false, title = 'WD40 Hero', isnew = false } = props
    return (
        <>
            {
                isnew ?
                    <div className={styles.heroContainer} {...props}>
                        {
                            mobileimage &&
                            <Imgix
                                sizes='100vw'
                                alt={title}
                                src={mobileimage}
                                className={styles.heroContainer_imageMobile}
                                htmlAttributes={{alt: title}}
                            />
                        }
                        <Imgix
                            sizes='100vw'
                            alt={title}
                            src={image}
                            className={styles.heroContainer_imageDesktop}
                            htmlAttributes={{alt: title}}
                        />
                    </div>
                    :
                    <div className={styles.heroContainerOld}>
                        <img
                            src={sizedSrc(image, 1440)}
                            srcSet={`${sizedSrc(image, 640)} 640w, ${sizedSrc(image, 1024)} 1024w, ${sizedSrc(image, 1440)} 1440w, ${sizedSrc(image, 1920)} 1920w`}
                            sizes='100vw'
                            alt={title}
                            fetchpriority='high'
                            className={styles.heroContainerImage} />
                    </div>
            }
        </>


    );
};

export default simpleHero;